const handler = ( $ ) => {
	const $loadMoreBtn = $( '.load-more' );

	if ( $loadMoreBtn.length == 0 ) {
		return;
	}

	const $defaultText = $( '.load-more__default-text', $loadMoreBtn ),
		$loadingText = $( '.load-more__load-text', $loadMoreBtn ),
		$errorMsg = $( '.error-msg' );

	const resetBtn = ( _hash ) => {
		const $btn = $( `.load-more[data-id="${ _hash }"` );

		$btn.attr( 'data-state', 'default' )
			.attr( 'data-id', '' )
			.attr( 'disabled', false );
	};

	const showErrorMsg = ( msg ) => {
		$loadMoreBtn.hide();
		$errorMsg.show().html( msg );

		setTimeout( () => {
			$errorMsg.hide().html( '' );
			$loadMoreBtn.show();
		}, 2500 );
	};

	const ajaxFailHandler = ( jqXHR, textStatus ) => {
		showErrorMsg( `Request failed: ${ textStatus }` );
	};

	const ajaxDoneHandler = ( response ) => {
		if ( ! response.success ) {
			showErrorMsg( response.data.output );
		}

		const $btn = $( `.load-more[data-id="${ response.data.hash }"` ),
			$articlesList = $btn.prev( 'ul' ),
			oldPage = $btn.attr( 'data-page' ),
			currentPage = +oldPage + 1;

		$articlesList.append( response.data.output );

		$btn.attr( 'data-page', currentPage );

		if ( $btn.attr( 'data-max-num-pages' ) == currentPage ) {
			$btn.hide();
		}
	};

	const ajaxCompleteHandler = ( response ) => {
		resetBtn( response.data.hash );
		$defaultText.show();
		$loadingText.hide();
	};

	const loadMoreBtnClickHandler = function () {
		const $btn = $( this ),
			queryArgs = $btn.attr( 'data-query-args' ) || {},
			hash = Date.now().toString( 36 ),
			data = {
				action: $btn.attr( 'data-action' ),
				page: $btn.attr( 'data-page' ),
				state: $btn.attr( 'data-state' ),
				hash: hash,
				queryArgs: JSON.parse( queryArgs ),
			};

		if ( data.state == 'loading' ) {
			return;
		}

		$btn.attr( 'data-state', 'loading' )
			.attr( 'data-id', hash )
			.attr( 'disabled', true );
		$defaultText.hide();
		$loadingText.show();

		$.post( window.themeVars.ajaxUrl, data )
			.done( ajaxDoneHandler )
			.fail( ajaxFailHandler )
			.always( ajaxCompleteHandler );
	};

	$loadMoreBtn.on( 'click', loadMoreBtnClickHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
